import { device } from '@ui-components/breakpoints';
import styled, { css } from 'styled-components';

export const StyledTopBarContainer = styled.div<{ noGradient?: boolean }>`
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 400;

    ${(props) =>
        !props.noGradient &&
        css`
            &:before {
                pointer-events: none;
                display: block;
                content: ' ';
                height: 200px;
                width: 100%;
                position: absolute;
                top: 0;
                left: 0;
                transition: transform 200ms ease-in;
                background: linear-gradient(
                    to top,
                    hsla(0, 0%, 0%, 0),
                    hsla(0, 0%, 0%, 0.00902) 4.24%,
                    hsla(0, 0%, 0%, 0.03481) 9.84%,
                    hsla(0, 0%, 0%, 0.0755) 16.61%,
                    hsla(0, 0%, 0%, 0.12919) 24.37%,
                    hsla(0, 0%, 0%, 0.19398) 32.94%,
                    hsla(0, 0%, 0%, 0.268) 42.13%,
                    hsla(0, 0%, 0%, 0.34935) 51.75%,
                    hsla(0, 0%, 0%, 0.43615) 61.63%,
                    hsla(0, 0%, 0%, 0.5265) 71.58%,
                    hsla(0, 0%, 0%, 0.61852) 81.41%,
                    hsla(0, 0%, 0%, 0.71031) 90.95%,
                    hsla(0, 0%, 0%, 0.8)
                );
            }
        `}
`;

export const StyledTopBar = styled.div<{ justifyEnd?: boolean }>`
    align-items: flex-start;
    display: flex;
    position: absolute;
    top: 25px;
    left: 9px;
    width: calc(100% - 18px);
    z-index: 2;

    @media ${device.GteLarge} {
        left: 19px;
        width: calc(100% - 38px);
    }

    ${({ justifyEnd }) =>
        justifyEnd &&
        css`
            justify-content: flex-end;
        `}
`;

export const TopBarMain = styled.div`
    flex: 1 1 auto;
    overflow-x: hidden;
    padding-right: 10px;
`;

export const TopBarVisuallyLeft = styled.div`
    order: -1;
    flex: 0 0 auto;
`;

export const TopBarVisuallyRight = styled.div`
    flex: 0 0 auto;
`;
